
import React from 'react';

import Startupanledbulb from './Startupanledbulb';
import Partsneedinject from './Partsneedinject';
import Rotaryinjec from './Rotaryinjec';
import Bulbcovertabl from './Bulbcovertabl';


const Startanledbu = () => {
    return (
        <div>
            <Startupanledbulb />
            <Partsneedinject />
            <Rotaryinjec />
            <Bulbcovertabl />

        </div>
    );
};

export default Startanledbu;
